import apiService from './api-service';

const DELETED_ENTITY_FUEL_TANK = 22;
const DELETED_ENTITY_USER = 25;
const DELETED_ENTITY_SUPPLIER = 34;
const DELETED_ENTITY_VEHICLE = 35;
const DELETED_ENTITY_DRIVER = 36;
const DELETED_ENTITY_DRIVER_COMPANY = 37;
const DELETED_ENTITY_TECHNICAL_DEVICE = 40;

export const azkService = {
    DELETED_ENTITY_FUEL_TANK,
    DELETED_ENTITY_USER,
    DELETED_ENTITY_SUPPLIER,
    DELETED_ENTITY_VEHICLE,
    DELETED_ENTITY_DRIVER,
    DELETED_ENTITY_DRIVER_COMPANY,
    DELETED_ENTITY_TECHNICAL_DEVICE,
    getEntities,
    forceGetEntities,
    createUser,
    updateUser,
    createFuelTank,
    updateFuelTank,
    updateGlobalSettings,
    updateTrk,
    updateGun,
    createGlobalSettings,
    createSupplier,
    updateSupplier,
    createCompany,
    updateCompany,
    createTechnicalDevice,
    updateTechnicalDevice,
    createDriver,
    updateDriver,
    createVehicle,
    updateVehicle,
    deleteEntity
};

async function getEntities() {
    const entities = await apiService.get('azk/getEntitiesByUserId');
    return entities;
}

async function forceGetEntities(clientId, fuelDepoId) {
    const payload = {
        clientId: clientId,
        fuelDepoId: fuelDepoId
    };

    const countUpdatedRows = await apiService.post('azk/forceGetEntities', payload);
    return countUpdatedRows;
}

async function createUser(user) {
    const countInsertedRows = await apiService.post('azkUser/createUser', user);
    return countInsertedRows;
}

async function updateUser(user) {
    const countUpdatedRows = await apiService.post('azkUser/updateUser', user);
    return countUpdatedRows;
}

async function updateGlobalSettings(globalSettings) {
    const payload = {
        globalSettings: globalSettings
    };

    const countUpdatedRows = await apiService.post('azkGlobalSetting/updateGlobalSettings', payload);
    return countUpdatedRows;
}

async function createGlobalSettings(clientId, globalSettings) {
    const payload = {
        clientId: clientId,
        globalSettings: globalSettings
    };

    const countUpdatedRows = await apiService.post('azkGlobalSetting/createGlobalSettings', payload);
    return countUpdatedRows;
}

async function createFuelTank(fuelTank) {
    const countUpdatedRows = await apiService.post('azkFuelTank/createFuelTank', fuelTank);
    return countUpdatedRows;
}

async function updateFuelTank(fuelTank) {
    const countUpdatedRows = await apiService.post('azkFuelTank/updateFuelTank', fuelTank);
    return countUpdatedRows;
}

async function updateTrk(trk) {
    const countUpdatedRows = await apiService.post('azkTrk/updateTrk', trk);
    return countUpdatedRows;
}

async function updateGun(gun) {
    const countUpdatedRows = await apiService.post('azkGun/updateGun', gun);
    return countUpdatedRows;
}

async function createSupplier(supplier) {
    const countUpdatedRows = await apiService.post('azkSupplier/createSupplier', supplier);
    return countUpdatedRows;
}

async function updateSupplier(supplier) {
    const countUpdatedRows = await apiService.post('azkSupplier/updateSupplier', supplier);
    return countUpdatedRows;
}

async function createCompany(company) {
    const countUpdatedRows = await apiService.post('azkCompany/createCompany', company);
    return countUpdatedRows;
}

async function updateCompany(company) {
    const countUpdatedRows = await apiService.post('azkCompany/updateCompany', company);
    return countUpdatedRows;
}

async function createTechnicalDevice(technicalDevice) {
    const countUpdatedRows = await apiService.post('azkTechnicalDevice/createTechnicalDevice', technicalDevice);
    return countUpdatedRows;
}

async function updateTechnicalDevice(technicalDevice) {
    const countUpdatedRows = await apiService.post('azkTechnicalDevice/updateTechnicalDevice', technicalDevice);
    return countUpdatedRows;
}

async function createDriver(driver) {
    const countUpdatedRows = await apiService.post('azkDriver/createDriver', driver);
    return countUpdatedRows;
}

async function updateDriver(driver) {
    const countUpdatedRows = await apiService.post('azkDriver/updateDriver', driver);
    return countUpdatedRows;
}

async function createVehicle(vehicle) {
    const countUpdatedRows = await apiService.post('azkVehicle/createVehicle', vehicle);
    return countUpdatedRows;
}

async function updateVehicle(vehicle) {
    const countUpdatedRows = await apiService.post('azkVehicle/updateVehicle', vehicle);
    return countUpdatedRows;
}

async function deleteEntity(entityId, entityType) {
    const countDeletedRows = await apiService.post('azk/deleteEntity', { entityId: entityId, entityType: entityType });
    return countDeletedRows;
}
